"use client";

import { c as _c } from "react/compiler-runtime";
import logo_image from "@/assets/images/changwei-logo.svg";
import { HeaderMenu } from "@/components/Header/HeaderMenu";
import { LanguageSwitcher } from "@/components/Header/LanguageSwitcher";
import { Space } from "antd";
import Image from "next/image";
import { Link } from "@/i18n/navigation";
import { useLocale, useTranslations } from "next-intl";
import React from "react";
import styles from "./Header.module.sass";
export interface IPropsHeader {}
export const Header: React.FunctionComponent<IPropsHeader> = () => {
  const $ = _c(27);
  const t = useTranslations("header");
  const locale = useLocale();
  let t0;
  if ($[0] !== t) {
    t0 = t("logoAlt");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <Link href="/" data-sentry-element="Link" data-sentry-source-file="Header.tsx"><div className={styles.logo}><Image src={logo_image} width={48} height={48} alt={t0} data-sentry-element="Image" data-sentry-source-file="Header.tsx" /></div></Link>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className={styles.split} />;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("siteTitleLine1");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <br />;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== locale) {
    t5 = locale === "en-US" ? "" : <>Chang Wei's website<br /></>;
    $[8] = locale;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      fontSize: 14,
      lineHeight: 1,
      color: "#8c8c8c"
    };
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t) {
    t7 = t("siteSubtitle");
    $[11] = t;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t7) {
    t8 = <span style={t6}>{t7}</span>;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t3 || $[16] !== t5 || $[17] !== t8) {
    t9 = <Link href="/" className={styles.title_link} data-sentry-element="Link" data-sentry-source-file="Header.tsx"><div className={styles.title}>{t3}{t4}{t5}{t8}</div></Link>;
    $[15] = t3;
    $[16] = t5;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t1 || $[20] !== t9) {
    t10 = <div className={styles.main_left}><Space align="center" className={styles.main_space} data-sentry-element="Space" data-sentry-source-file="Header.tsx">{t1}{t2}{t9}</Space></div>;
    $[19] = t1;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  let t12;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <HeaderMenu data-sentry-element="HeaderMenu" data-sentry-source-file="Header.tsx" />;
    t12 = <div className={styles.right_split} aria-hidden={true} />;
    $[22] = t11;
    $[23] = t12;
  } else {
    t11 = $[22];
    t12 = $[23];
  }
  let t13;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className={styles.right}>{t11}{t12}<div className={styles.language_switcher_wrap}><LanguageSwitcher data-sentry-element="LanguageSwitcher" data-sentry-source-file="Header.tsx" /></div></div>;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t10) {
    t14 = <header className={styles.container} data-sentry-component="Header" data-sentry-source-file="Header.tsx"><div className={styles.main}>{t10}{t13}</div></header>;
    $[25] = t10;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  return t14;
};